import i18n from "@microdoing/shared/i18n";
import { getFilesToUpload } from "@microdoing/shared/services/upload/selectors";
import { isWeb } from "@microdoing/shared/utils/deviceDetectors";
import {
  Box,
  MainButton,
  MainText,
  PressableOpacity,
} from "app/components/common";
import CameraIcon from "app/scenes/Signup/Icons/CameraIcon";
import theme from "app/Theme/Theme";
import React, { useEffect } from "react";
import { StyleSheet } from "react-native";
import Modal from "react-native-modal";
import { useSelector } from "react-redux";
import GalleryIcon from "../FeedbackScreen/icons/GalleryIcon";
import PlusIcon from "../FeedbackScreen/icons/PlusIcon";
import { useLaunchCamera } from "../FeedbackScreen/useLaunchCamera";

const styles = StyleSheet.create({
  modalStyle: {
    margin: 0, // This is the important style you need to set
    alignItems: "center",
    justifyContent: "flex-end",
    marginBottom: 60,
  },
});

export interface IUploadModalProps {
  isModalVisible: boolean;
  setIsModalVisible: (status: boolean) => void;
}

const UploadProfilePicture = ({
  isModalVisible,
  setIsModalVisible,
}: IUploadModalProps) => {
  const [error, setError, openNativeModule] = useLaunchCamera({
    hasPhotoOption: true,
    hasVideoOption: false,
  });

  const filesToUpload = useSelector(getFilesToUpload);

  useEffect(() => {
    setIsModalVisible(false);
  }, [filesToUpload]);

  return (
    <Modal
      backdropTransitionOutTiming={0}
      style={styles.modalStyle}
      animationIn="slideInUp"
      useNativeDriver
      backdropColor={theme.colors["neutral.600"]}
      backdropOpacity={0.7}
      hideModalContentWhileAnimating
      isVisible={isModalVisible}
      onBackdropPress={() => setIsModalVisible(false)}
    >
      <Box
        backgroundColor="neutral.white"
        padding="s"
        marginHorizontal="xl"
        alignItems="center"
        borderRadius={8}
      >
        <MainButton
          onPress={openNativeModule("gallery", 1)}
          leftIcon={
            <Box marginRight="xm">
              <GalleryIcon color={theme.colors["brand.500"]} />
            </Box>
          }
          rightIcon={<PlusIcon color={theme.colors["brand.500"]} />}
          text="Upload photo"
          color="neutral.50"
          textColor="neutral.900"
          textVariant={"l3-semibold"}
          height={56}
        />
        {!isWeb && (
          <MainButton
            onPress={openNativeModule("photo", 1)}
            leftIcon={
              <Box marginRight="xm">
                <CameraIcon color={theme.colors["brand.500"]} />
              </Box>
            }
            rightIcon={<PlusIcon color={theme.colors["brand.500"]} />}
            textVariant={"l3-semibold"}
            text="Take a photo"
            color="neutral.50"
            textColor="neutral.900"
            height={56}
          />
        )}
        <Box marginTop="s" marginBottom="s">
          <PressableOpacity onPress={() => setIsModalVisible(false)}>
            <MainText variant="l3-semibold" color="neutral.500">
              {i18n.t("close")}
            </MainText>
          </PressableOpacity>
        </Box>
      </Box>
    </Modal>
  );
};

export default UploadProfilePicture;
